import "@/App.css";
import { useEffect } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { LandingPage } from "@/pages/LandingPage";
import { AuthPage } from "@/pages/AuthPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { RoleSetup } from "@/pages/RoleSetup";
import { EmployeeDashboard } from "@/pages/EmployeeDashboard";
import { EmployerDashboard } from "@/pages/EmployerDashboard";
import { GeofencingPage } from "@/pages/GeofencingPage";
import { TermsPage } from "@/pages/TermsPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { ContactPage } from "@/pages/ContactPage";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { SubscriptionPage, SubscriptionSuccessPage, PaywallPage } from "@/pages/SubscriptionPage";
import { AdminDashboard } from "@/pages/AdminDashboard";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/subscription" element={<SubscriptionPage />} />
      <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
      <Route path="/subscription/cancel" element={<SubscriptionPage />} />
      <Route path="/paywall" element={<PaywallPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route 
        path="/setup" 
        element={
          <ProtectedRoute requireRole={false}>
            <RoleSetup />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/employee" 
        element={
          <ProtectedRoute requiredRole="employee">
            <EmployeeDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/employer" 
        element={
          <ProtectedRoute requiredRole="employer">
            <EmployerDashboard />
          </ProtectedRoute>
        } 
      />
      <Route path="/dashboard" element={<DashboardRedirect />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route 
  path="/employer/geofencing" 
  element={
    <ProtectedRoute requiredRole="employer">
      <GeofencingPage />
    </ProtectedRoute>
  } 
/>
    </Routes>
  );
}

function DashboardRedirect() {
  return (
    <ProtectedRoute>
      <div />
    </ProtectedRoute>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

function AppContent() {
  const { language } = useLanguage();

  useEffect(() => {
    if (!language) return;

    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  }, [language]);

  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
